<script setup lang="ts">
import BaseButtonMuted from '../base/BaseButtonMuted.vue'
import BaseButtonPrimary from '../base/BaseButtonPrimary.vue'
import { navigateToNextStep, navigateToPreviousStep } from '../../utilities/account/useInvestmentProcessNavigation'
import { i18n } from '../../localization'
import { getCurrentInstance, nextTick, onMounted, onUnmounted, ref } from 'vue'

const props = withDefaults(
    defineProps<{
        nextButtonText: string
        backButtonText: string
        nextButtonDisabled: boolean
        onNextClick: () => void
        onBackClick: () => void
        isSticky?: boolean
    }>(),
    {
        nextButtonText: i18n.global.t('investment_process.next'),
        backButtonText: i18n.global.t('investment_process.back'),
        nextButtonDisabled: false,
        onNextClick: navigateToNextStep,
        onBackClick: navigateToPreviousStep,
        isSticky: true,
    }
)

const elementId = ref(null)
const instance = getCurrentInstance()
const element_bottom = ref(null)

function handleSticky(): void {
    const window_bottom = document.scrollingElement.scrollTop + window.innerHeight
    const element = document.getElementById(elementId.value)
    if (!element) {
        nextTick(() => handleSticky())
        return
    }
    if (!element_bottom.value) {
        calculateElementBottom()
    }

    if (window_bottom < element_bottom.value) {
        element.style.position = 'sticky'
        element.style.bottom = '20px'
    } else {
        element.style.position = 'relative'
        element.style.bottom = null
    }
}

function calculateElementBottom(): void {
    const element = document.getElementById(elementId.value)
    element_bottom.value = element && element.offsetTop ? element.offsetTop + element.offsetHeight + 40 : 0
    handleSticky()
}

onMounted(() => {
    if (props.isSticky) {
        elementId.value = `stickyButton_${instance.uid}`
        window.addEventListener('scroll', handleSticky)
        window.addEventListener('resize', calculateElementBottom)
        handleSticky()
    }
})

onUnmounted(() => {
    if (props.isSticky) {
        window.removeEventListener('scroll', handleSticky)
        window.removeEventListener('resize', calculateElementBottom)
    }
})
</script>

<template>
    <div :id="elementId" class="sticky-button flex justify-between pt-6">
        <BaseButtonMuted @click="props.onBackClick()">{{ props.backButtonText }}</BaseButtonMuted>
        <BaseButtonPrimary
            :disabled="nextButtonDisabled"
            :loading="nextButtonDisabled"
            class="font-semibold"
            @click="props.onNextClick()"
            >{{ props.nextButtonText }}
        </BaseButtonPrimary>
    </div>
</template>

<style scoped></style>
